import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  StyledModal,
  StyledTitle,
  StyledBody,
  ManageAnniversariesContainer,
  Button,
} from "./styles";
import { RecognitionCloseIcon, RecognitionTickIcon } from "../../../utils/icons";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import { PutBirthdayAndAnniversaryCardToggle } from "../../../redux/constants/apiConstants";
import { InputContainer } from "../../CreateEvent/styles";
import { StyledInputV2, StyledLabel } from "../../CreateEvent/style";
import { t } from "i18next";

const AniBiPointsModal = ({ showModal, onClose, companyId, isBirthday, isAnniversary, title, anniversaryPoint, birthdayPoint, isUpdateBirthdayPoints, isUpdateAnniversaryPoints }) => {
  //   const [isLoading, setIsLoading] = useState(false);
  const [anniversaryPointValue, setAnniversaryPointValue] = useState(anniversaryPoint);
  const [birthdayPointPointValue, setBirthdayPointPointValue] = useState(birthdayPoint);

  useEffect(() => {

  }, [])

  const saveChanges = async (e) => {
    e.preventDefault();
    // setIsLoading(true);

    const payload = {
      company_id: companyId,
      show_birthday_card: isBirthday ? 1 : 0,
      show_work_anniversary_card: isAnniversary ? 1 : 0,
      birthday: isBirthday ? Number(birthdayPointPointValue) : 0,
      anniversary: isAnniversary ? Number(anniversaryPointValue) : 0
    };

    try {
      const res = await fetchApi(PutBirthdayAndAnniversaryCardToggle, "PUT", payload);
      if (res.status === "success") {
        toast.success(res.data[0]);
        onClose()
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      //   setIsLoading(false);
    }
  };


  //   const setPointValues = ()=>{
  //     setNextModal(false);
  //     setPointsModal(true);
  //   }



  return (
    <>
      <StyledModal show={showModal} newWidth="400px" newBg="newBg" display="none">
        <Modal.Header closeButton onHide={onClose} style={{ background: "white" }}>
          <StyledTitle>{title || "Adding Points"}</StyledTitle>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            {RecognitionCloseIcon()}
          </div>
        </Modal.Header>

        <StyledBody>
          <ManageAnniversariesContainer marginTopToggle="8px">

            {isBirthday ? <InputContainer widthInput marginTop="20px">
              <StyledLabel color={"#184A61"} margin="0px">{t("How many points would you like to award an employee on their birthday?")}</StyledLabel>
              <StyledInputV2
                placeholder={t("Input your point value")}
                name="title"
                value={birthdayPointPointValue}
                maxLength="25"
                style={{ background: "white" }}
                pColor={"#BDBDBD"}
                color="#005c87"
                onChange={(e) => setBirthdayPointPointValue(e.target.value)}
                isBorderColor={"1px solid #BDBDBD"}
                type="number"
                disabled={isUpdateBirthdayPoints}
              />
            </InputContainer> : null}

            {isAnniversary ? <InputContainer widthInput>
              <StyledLabel color={"#184A61"} margin="16px">{t("How many points would you like to award an employee on their work anniversary?")}</StyledLabel>
              <StyledInputV2
                placeholder={t("Input your point value")}
                name="title"
                value={anniversaryPointValue}
                maxLength="25"
                style={{ background: "white" }}
                pColor={"#BDBDBD"}
                color="#005c87"
                onChange={(e) => setAnniversaryPointValue(e.target.value)}
                isBorderColor={"1px solid #BDBDBD"}
                type="number"
                disabled={isUpdateAnniversaryPoints}
              />
            </InputContainer> : null}

            <div className="second-text">
              {(isUpdateBirthdayPoints && isUpdateAnniversaryPoints) ? `You've already updated this year's points once.` : null}
            </div>
            <div className="enable-text">
              {(isUpdateBirthdayPoints && isUpdateAnniversaryPoints) ? `Enabling the ${isBirthday && isAnniversary ? 'birthday and work anniversary' : isBirthday ? "birthday" : isAnniversary ? "work anniversary" : 'birthday and work anniversary'}` : null}
            </div>

          </ManageAnniversariesContainer>


          <Button isWidth="151px" isHeight="40px" background="#F37A65" color="white" onClick={saveChanges}>
            Save Changes
            <div style={{marginLeft:"8px"}}> {RecognitionTickIcon("white")}</div> 
          </Button>
        </StyledBody>
      </StyledModal>

    </>
  );
};

AniBiPointsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  isBirthday: PropTypes.bool,
  isAnniversary: PropTypes.bool,
  title: PropTypes.string,
  anniversaryPoint: PropTypes.number,
  birthdayPoint: PropTypes.number,
  isUpdateBirthdayPoints: PropTypes.number,
  isUpdateAnniversaryPoints: PropTypes.number,
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
});

export default connect(mapStateToProps, null)(AniBiPointsModal);
